<template>
	<div id="app">
		<!-- <Main /> -->
		<router-view />
		<Footer />
	</div>
</template>
<script>
	// import Main from '@/components/Main.vue';
	import Footer from '@/components/Footer.vue';

	export default {
		data() {
			return {
			}
		},
		components: {
			// Main,
			Footer
		},
		mounted() {
			console.log(window.scrollY)
		},
	}
</script>